module.exports = __webpack_public_path__ + "static/media/13.d3d65aac.jpg";